import {View} from 'backbone';
import _template from 'dashboard/reports/report-workspace-dashboard.ejs';
import filtersView from 'dashboard/workspace-table-filters.ejs';
import Spinner from 'spin/spin';
import constants from 'Constants.js';
import reportAddService from 'ReportAddService.js';
import restService from 'RestService';
import formLoadService from 'FormLoadService.js';
import notificationService from 'NotificationService';
import reportService from 'ReportService.js';
import listService from 'ListService.js';
import util from 'util/Util';
import workspaceCommon from 'WorkspaceTableCommon';
import commonService from 'CommonService';
import eventBus  from 'EventBus';
class ReportWorkspaceView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.data = [];
        this.dataLoaded = false;

        this.events = {
            'click .new': 'createNewReport',
            'click #new-report': 'createNewReport'
        };

        if (!util.hasEventListener(eventBus._events, 'reloadTableReport')) {
            this.listenTo(eventBus, 'reloadTableReport', this.reloadTable);
        }       

        this.getAllData();

        return this;
    }

    reloadTable(){
        this.getAllData(true);  
    }

    getAllData(reload){
        const self = this;
        commonService.getAll("reports").then((result) => {   
            self.data = [];
            if (result) {
                const reports = util.enforceArrayType(result);
                reports.forEach((report) => {
                    this.data.push(
                        {
                            id: report["@id"],
                            name: report["@name"],
                            appName: { name: report["@name"], lastUpdate: report["@LastUpdateDate"] },
                            version: report["@Version"],
                            status: util.isTrue(report["@IsDeployed"]) ? "Published" : "Draft",
                            active: util.isTrue(report["@IsActive"]) ? "Yes" : "No",
                            isPrivate: util.isTrue(report["@IsPrivate"]),
                            ownerName: report["@Owner"] || "Owner Name",
                            appFunctions: {
                                permissions: !util.isEmpty(report["UserPermissionsXML"]) ? report["UserPermissionsXML"].Permissions: null,
                                design: this.loadReportDesigner,
                                link: this.openReportLink,
                                publish: this.publishReport,
                                view: this.viewReport,
                                favorite: { val: util.isTrue(report["@IsFavorite"]), objType: constants.FAVORITE_REPORT_OBJTYPE },
                                contextMenu: ".table-context-menu"
                            }
                        }
                    )
                });
                //self.data.sort((a, b) => Date.parse(b.appName.lastUpdate) - Date.parse(a.appName.lastUpdate));
            }
            self.dataLoaded = true;
            if (reload) {
                workspaceCommon.reloadTable(self.data, "Report");
            }            
        });
    }    

    createNewReport(){
        
        const groupIdToAdd = constants.DEFAULT_GROUP_ID;
        const selectedNodeTarget = constants.EDIT_FORMS_CONTAINER;
        const selectedGroupType = constants.FORMS_PRIVATE_GROUP_TYPE;
        let selectedNodeOnTree;

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        sessionStorage.setItem('appTourTag', '_tReport');

        reportAddService.newReport(groupIdToAdd, selectedGroupType, selectedNodeTarget,
            selectedNodeOnTree, reportAddService.defaultReport, constants.DEFAULT_REPORT_NAME, true).then(result => {

                restService.getReportDetails(result.reportId).then((reportDetailsResult) => {
                    const reportDetails = reportDetailsResult.RESULT.RESPONSE.PrivateReportDetails;
                    
                    const reportModel = reportService.createNewModel(result.reportId, reportDetailsResult);
                    listService.dashboardLayout.mainPanelView.model = reportModel;

                    formLoadService.loadReport(result.reportId, "0", "1", reportDetails.Name, reportDetails.Version, reportDetails.LastUpdate).then(msg => {
                        spinner.stop();
                    }, (errMsg) => {
                        notificationService.error(errMsg);
                    });
                });

                spinner.stop();

            }, error => {
                notificationService.error(error);
                spinner.stop();
            }).catch(errMsg => {
                notificationService.error(errMsg);
                spinner.stop();

            });
    }

    createTable() {

        const appsTable = $('#apps-table');
        workspaceCommon.bindIconsEvents();
        const self = this;
           
        const startTable = () => {
            if(self.dataLoaded){
                appsTable.bootstrapTable({
                    pagination: true,
                    classes: 'table table-hover table-striped table-borderless',
                    paginationParts: ['pageInfo', 'pageList'],
                    columns: [{
                        field: 'id',
                        visible: false
                    },
                    {
                        field: 'name',
                        visible: false
                    },
                    {
                        field: 'isPrivate',
                        visible: false
                    },
                    {
                        field: 'appName',
                        title: 'Report Name',
                        formatter: workspaceCommon.appNameFormatter
                    },
                    {
                        field: 'ownerName',
                        title: 'Owner'
                    },
                    {
                        field: 'version',
                        title: 'Version',
                        align: 'center'
                    },
                    {
                        field: 'status',
                        title: 'Status',
                        align: 'center'
                    },
                    {
                        field: 'active',
                        title: 'Active',
                        align: 'center'
                    },
                    {
                        field: 'appFunctions',
                        title: '',
                        align: 'center',
                        clickToSelect: false,
                        events: appOptionsEv,
                        formatter: workspaceCommon.iconFormatter
                    }],
                    data: self.data,
                    onDblClickRow: (rowData, $el, colCliked) => {
                        //if(rowData.appFunctions.permissions){
                            const isBasic = rowData.appFunctions.permissions ? false : true;
                            self.openDetails(rowData.id, isBasic);
                        //}
                    }
                });

                workspaceCommon.showScreen(self.data.length, "Report");

                let paginationText = $(".pagination-info").text().replace("rows", "reports");
                $(".pagination-info").text(paginationText);
            }
            else{
                setTimeout(startTable, 50);
            }
        }
        startTable();
    }

    openDetails(reportId, isBasic){
        const refreshButton = $('#pf-refresh-main-view');
        refreshButton.attr("data-appid", reportId);
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{

            if(isBasic){
                model.set("simpleView", true);
            }
            
            commonService.openDetailsView(model, "report");
        });
    }

    loadReportDesigner(reportId){
        sessionStorage.setItem('appTourTag', ''); 
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            commonService.loadDesigner(model, "report");
        });
    }

    openReportLink(reportId){
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            commonService.openLink(model.get("reportId"), model.get("reportName"), model);
        });       
    }

    publishReport(reportId){
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            commonService.publishValidations(model, "report");
        }); 
        
    }

    viewReport(reportId){
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            reportService.viewReport(model.get("LinkId"));
        }); 
      
    }

    deleteReport(reportId){
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            commonService.delete(model, "report");
        });        
    }

    migrateReport(reportId){
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            commonService.migrate(model, "report");
        });  
    }

    permissionsReport(reportId){
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            commonService.permissions(model, "report");
        }); 
    }

    shareReport(reportId){
        commonService.getModel(reportId, "report", reportService.createNewModel).then((model)=>{
            commonService.share(model, "report");
        }); 
    }
   
    render() {
        this.$el.html(this.template(this.model.toJSON()));

        $("#search-filters").html(filtersView);


        if (listService.accountSettings.license.UsedReports > 0) {
           
            this.createTable();
            
            const menu = [  { name: "Report Details", fxClass: "details-app report-details", style: "", fx: this.openDetails },
                { name: "Design", fxClass: "design-app", style: "", fx: this.loadReportDesigner },
            { name: "Publish", fxClass: "publish-app", style: "", fx: this.publishReport },
            null,
            { name: "View", fxClass: "view-app", style: "", fx: this.viewReport },
            { name: "Link", fxClass: "link-app", style: "", fx: this.openReportLink },
            null,
            { name: "Share", fxClass: "share-app admin-fx", style: "", fx: this.shareReport },
            { name: "Permissions", fxClass: "permissions-app admin-fx", style: "", fx: this.permissionsReport },
            { name: "Migrate", fxClass: "migrate-app admin-fx", style: "", fx: this.migrateReport },
            null,
            { name: "Delete", fxClass: "delete-app admin-fx", style: "color:#F01212", fx: this.deleteReport } ];

            workspaceCommon.buildTableContextMenu(menu, $(".table-context-menu"));
        }
        else {
            workspaceCommon.showScreen(0, "Report");
        }

        this.delegateEvents();
        workspaceCommon.bindSearchFilterEvents($("#apps-table"));
        return this;
    }
}

export default ReportWorkspaceView;